import React, { useState, useContext } from "react";
import { Paper, Container, Button, Stack, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";

import { simpleMessage } from "../../../../helpers/Helpers";
import { addAdelantoAsync } from "../../../../api/Employees";

const AddAdelanto = ({ id, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState("");

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const token = getToken();

  const saveChanges = async () => {
    if (monto.length === 0) {
      simpleMessage("Ingrese una descripcion", "error");
      return;
    }

    const data = {
      employeeId: id,
      monto,
    };

    setIsLoading(true);
    const result = await addAdelantoAsync(token, data);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);
    simpleMessage("Registro Agregado...!", "success");

    setReload(!reload);
    setShowModal(false);
  };

  //Devuelve un entero positivo
  const funtionSetMonto = (value) => {
    if (/^\d*\.?\d*$/.test(value.toString()) || value === "") {
      setMonto(value);
      return;
    }
  };

  return (
    <div>
      <Container style={{ width: 550 }}>
        <Paper
          elevation={10}
          style={{
            padding: 20,
          }}
        >
          <Stack spacing={2}>
            <TextField
              required
              fullWidth
              onChange={(e) => funtionSetMonto(e.target.value)}
              value={monto}
              label={"Monto Adelanto"}
            />

            <Button
              variant="outlined"
              startIcon={
                <FontAwesomeIcon
                  icon={faCirclePlus}
                  style={{ marginRight: 20 }}
                />
              }
              fullWidth
              onClick={() => saveChanges()}
              style={{
                borderRadius: 30,
                color: "#4caf50",
                borderColor: "#4caf50",
                padding: 12,
              }}
              size="large"
            >
              Agregar Adelanto
            </Button>
          </Stack>
        </Paper>
      </Container>
    </div>
  );
};

export default AddAdelanto;
